import modals from "webmodals/modals";
import BasicAutoQueryController from "servicestack/auto-query/auto-query.controller";
import AutoQuery from "servicestack/auto-query/auto-query";

export default class JobSchedulerLogController extends BasicAutoQueryController {
  constructor() {
    super();
    let $ctrl = this;
  }
  $onInit() {
    console.info("jobScheduler");
    const $ctrl = this;
    super.$onInit && super.$onInit();
    $ctrl.query = new AutoQuery($ctrl.getQueryOptions());
  }
  getQueryOptions() {
    const $ctrl = this;
    return {
      url: "QueryJobProcessLog.json",
      pageSize: 12,
      //append: true,
      autoLoad: true,
      hideLeftNav: true,
      filters: [{ groupBy: "JobType", title: "JobType" }],
      sortOptions: {
        JobType: "Job Type: A to Z",
        "-JobType": "Job Type: Z to A",
        JobDescription: "Job Description: A to Z",
        "-JobDescription": "Job Description: Z to A",
        ExecutedOn: "Executed On: Latest",
        "-ExecutedOn": "Executed On: Oldest",
      },
    };
  }
}
